import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Slevamat = {
	name: NAME,
	apiProvider,
	router,
};
